import request from '@/utils/request';

// H5 分享订单详情（凭分享码）
export function getShareOrderDetail(params) {
  return request({
    url: '/logistic/h5/api/ordershare/getOrderDetail',
    method: 'GET',
    params,
    headers: {
      isToken: false
    }
  });
}

// H5 冷藏数据详情（凭分享码）
export function getColdDataDetail(params) {
  return request({
    url: '/logistic/miniapp/api/ordershare/getDeviceSensorData',
    method: 'GET',
    params,
    headers: {
      isToken: false
    }
  });
}
